import * as React from 'react';
import * as _ from 'lodash';
import {InferableComponentEnhancer} from 'recompose';
import {formValueSelector} from 'redux-form';
import formConnect from '../formConnect';

export interface Computation<FormData extends object, ComputationFields extends keyof FormData, P extends object = {}> {
  fieldNames: ComputationFields[];
  propsGenerator: (values: Pick<FormData, ComputationFields>) => P;
}

const getFormValues = _.memoize(form => (state, fieldNames) => formValueSelector(form)(state, 'dummmy', ...fieldNames));

function createComputed<FormData extends object, ComputationFields extends keyof FormData, P extends object = {}>(
  computation: Computation<FormData, ComputationFields, P>
): InferableComponentEnhancer<P> {
  const {fieldNames, propsGenerator} = computation;
  return formConnect<P>((state, {form}: any) => {
    return propsGenerator(getFormValues(form)(state, fieldNames));
  });
}

export default createComputed;
